import { render, staticRenderFns } from "./ImportExportWizard.template.vue?vue&type=template&id=6af96020&scoped=true&"
var script = {}
import style0 from "./ImportExportWizard.template.vue?vue&type=style&index=0&id=6af96020&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af96020",
  null
  
)

export default component.exports